import { ProjectContext } from "@/context/project.context";
import { useContext } from "react";
import ProjectVideoBox from "./ProjectVideoBox";
import { APP_MEEYPROJECT_URL } from "@/constants/environment";
import Link from "next/link";

const AboutProject = () => {
  const { project, projectVideos } = useContext(ProjectContext);
  return (
    <div className="bg-white p-4 h-full text-fs-14">
      {projectVideos?.length ? (
        <ProjectVideoBox />
      ) : (
        <>
          <div dangerouslySetInnerHTML={{ __html: project.description }}></div>
          <Link
            href={
              APP_MEEYPROJECT_URL +
              "/project/" +
              project.slug +
              "-" +
              project.shortId
            }
            target="_blank"
            className="text-blue-500 cursor-pointer">
            Xem thêm
          </Link>
        </>
      )}
    </div>
  );
};

export default AboutProject;
